function swapRows(board, ii1, ii2) {
  const row1 = board[ii1];
  board[ii1] = board[ii2];
  board[ii2] = row1;
}


function swapCols(board, jj1, jj2) {
  for (const row of board) {
    const val1 = row[jj1];
    row[jj1] = row[jj2];
    row[jj2] = val1;
  }
}


// function swapRowCol(board, ii, jj) {
//   const row = board[ii];
//   const col = board.map(r => r[jj]);
//   board[ii] = col;
//   for (let idx = 1; idx < board.length; idx++) {
//     board[idx][jj] = row[idx];
//   }
// }


export function swap(board, active, ii, jj) {
  if (active[1] === 0 && jj === 0) {
    swapRows(board, active[0], ii);
  } else if (active[0] === 0 && ii === 0) {
    swapCols(board, active[1], jj);
  } else if (active[0] === 0 && jj === 0) {
    // swapRowCol(board, ii, active[1]);
  } else if (active[1] === 0 && ii === 0) {
    // swapRowCol(board, active[0], jj);
  }
  return board;
}


export function countSquares(board) {
  const counts = {
    0: 0,
    1: 0,
    2: 0,
  };
  for (const row of board.slice(1)) {
    row.slice(1).forEach((val) => { counts[val] += 1; });
  }
  return counts;
}


function breathing(board, ii, jj) {
  const enemy = (board[ii][jj] + 1) % 2;
  const neighbours = [[ii, jj + 1], [ii, jj - 1], [ii + 1, jj], [ii - 1, jj]];
  for (const [ii2, jj2] of neighbours) {
    if (ii2 > 0 && jj2 > 0 && ii2 < board.length && jj2 < board.length && board[ii2][jj2] !== enemy) {
      return true;
    }
  }
  return false;
}


export function conquer(board, whoFirst) {
  const whoSecond = (whoFirst + 1) % 2;
  for (const nowConquering of [whoFirst, whoSecond]) {
    const beingConquered = (nowConquering + 1) % 2;
    for (let ii = 1; ii < board.length; ii++) {
      for (let jj = 1; jj < board.length; jj++) {
        if (board[ii][jj] === beingConquered && !breathing(board, ii, jj)) {
          board[ii][jj] = nowConquering;
        }
      }
    }
  }
}


export function isSameSwap(swap1, swap2) {
  if (swap1 === null || swap2 === null) {
    return false;
  }
  if (JSON.stringify(swap1) === JSON.stringify(swap2)) {
    return true;
  }
  if (JSON.stringify(swap1) === JSON.stringify([swap2[1], swap2[0]])) {
    return true;
  }
  return false;
}
